// extracted by mini-css-extract-plugin
export var legendIndicator = "_e4-1";
export var legendRight = "_e4-0";